import { Button } from "@/src/components/buttons";
import { CompartmentCard } from "@/src/components/cards";
import {
  openConfirmDialog
} from "@/src/components/dialogs";
import {
  FieldsSection,
  ScoreInterval
} from "@/src/data/allTypes";
import { uid, updateOrPush } from "@/src/utils/utils";
import { useState } from "react";
import { FiEdit2, FiTrash } from "react-icons/fi";
import { openFieldForm } from "./fieldForm";
import { openFieldsSectionsForm } from "./fieldsSectionForm";
import ReorderableFields from "./reorderableFields";
import TableSectionFields from "./tableSectionFields";

export default function ReorderableSections({
  label,
  scoreIntervals,
  onScoreIntervalsChange,
  current,
  onChange,
}: {
  label?: string | null | undefined;
  scoreIntervals: (ScoreInterval | null | undefined)[] | undefined | null;
  onScoreIntervalsChange:
    | ((newValue: (ScoreInterval | null | undefined)[]) => void)
    | undefined
    | null;
  current: (FieldsSection | null | undefined)[];
  onChange: (newValue: (FieldsSection | null | undefined)[]) => void;
}) {
  const [sections, setSections] = useState(current || []);
  const [reload, setReload] = useState(0);

  return (
    <div className="grid c1 gap10">
      {label ? <label>{label}</label> : null}

      {sections?.length != 0 && (
        <div className="grid c1 gap20">
          {sections?.map((fieldsSection, index) => {
            if (!fieldsSection) return null;
            return (
              <CompartmentCard
                key={uid()}
                className={
                  fieldsSection.isCommonWithSnomedChildren
                    ? "redish"
                    : fieldsSection.fields?.length == 0
                    ? ""
                    : "blueish"
                }
                title={
                  <div
                    className="cauto-1 gap10 acenter"
                    style={{ gridTemplateColumns: "auto auto auto 1fr" }}
                  >
                    <div>
                      {fieldsSection?.name}{" "}
                      <div className="gray">
                        {fieldsSection.isCommonWithSnomedChildren == true &&
                          "(commune)"}
                      </div>
                    </div>
                    <Button
                      additionalStyle={{ width: "50px" }}
                      type={"tertiary"}
                      onClick={async () => {
                        await openFieldsSectionsForm({
                          allSections: sections,
                          current: fieldsSection,
                          onSave: (fieldsSection) => {
                            const newSections = updateOrPush(
                              [...sections],
                              fieldsSection
                            );
                            setSections(newSections);
                            onChange(newSections);
                            setReload(reload + 1);
                          },
                        });
                      }}
                    >
                      <FiEdit2 size={16} />
                    </Button>
                    <Button
                      additionalStyle={{ width: "50px" }}
                      type={"tertiary"}
                      color="red"
                      onClick={async () => {
                        openConfirmDialog({
                          id: "deleteSection",
                          content:
                            "Voulez-vous vraiment supprimer cette section ?",
                          onConfirm: async () => {
                            let newSections = [...sections];
                            newSections = newSections.filter(
                              (section, i) => i != index
                            );
                            setSections(newSections);
                            onChange(newSections);
                          },
                        });
                      }}
                    >
                      <FiTrash size={16} />
                    </Button>
                    <div></div>
                  </div>
                }
                buttonTitle="Ajouter un champ"
              >
                <div className="c1 gap10">
                  {fieldsSection.type != "table" && (
                    <ReorderableFields
                      key={uid()}
                      allSections={sections}
                      onAddClick={() => {
                        openFieldForm({
                          sections,
                          current: null,
                          onSave: (field) => {
                            fieldsSection.fields = updateOrPush(
                              fieldsSection.fields || [],
                              field
                            );
                            setSections([...sections]);
                            onChange([...sections]);
                            setReload(reload + 1);
                          },
                        });
                      }}
                      scoreIntervals={scoreIntervals}
                      onScoreIntervalsChange={
                        onScoreIntervalsChange == null
                          ? undefined
                          : (newScoreIntervals) => {
                              onScoreIntervalsChange?.(newScoreIntervals);
                            }
                      }
                      currentValue={fieldsSection?.fields || []}
                      onChange={async (newFields) => {
                        fieldsSection.fields = newFields;

                        let newSections = [...sections];
                        setSections(newSections);
                        onChange(newSections);
                      }}
                    ></ReorderableFields>
                  )}
                  {fieldsSection.type == "table" && (
                    <TableSectionFields
                      key={uid()}
                      section={fieldsSection}
                      allSections={sections}
                      currentValue={fieldsSection?.fields || []}
                      onChange={async (newFields) => {
                        fieldsSection.fields = newFields;
                        let newSections = [...sections];
                        setSections(newSections);
                        onChange(newSections);
                      }}
                    ></TableSectionFields>
                  )}
                  {fieldsSection.type != "table" &&
                    fieldsSection.fields?.length != 0 && (
                      <Button
                        type={"primary"}
                        additionalStyle={{ width: "100px" }}
                        onClick={async () => {
                          openFieldForm({
                            sections,
                            current: null,
                            onSave: (field) => {
                              fieldsSection.fields = updateOrPush(
                                fieldsSection.fields || [],
                                field
                              );
                              setSections([...sections]);
                              onChange([...sections]);
                              setReload(reload + 1);
                            },
                          });
                        }}
                      >
                        +
                      </Button>
                    )}
                </div>
              </CompartmentCard>
            );
          })}
        </div>
      )}

      <Button
        type={"tertiary"}
        additionalStyle={{ width: "180px" }}
        onClick={async (e) => {
          await openFieldsSectionsForm({
            allSections: sections,
            current: null,
            onSave: (fieldsSection) => {
              const newSections = updateOrPush([...sections], fieldsSection);
              setSections(newSections);
              onChange(newSections);
              setReload(reload + 1);
            },
          });
        }}
      >
        Ajouter une section
      </Button>
    </div>
  );
}
